import { render, staticRenderFns } from "./VaAvatar.vue?vue&type=template&id=a11a4466&"
import script from "./VaAvatar.vue?vue&type=script&lang=js&"
export * from "./VaAvatar.vue?vue&type=script&lang=js&"
import style0 from "./VaAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports